import { createApp } from "vue";
import { watchFavourites } from "../vue/favourites/State";
import Lifestyle from "../vue/filters/Lifestyle";
import Results from "../vue/filters/Results.vue";
import Favourites from "../vue/favourites/Favourites.vue";
import Configurator from "../vue/product-configurator/configurator";
import Summarywrapper from "../vue/Summarywrapper";
import Compare from "../vue/compare-models/Compare.vue";
import Twigwrapper from "../vue/Twigwrapper.vue";
import Favouritebutton from "../vue/Favouritebutton.vue";
import Favouritesbutton from "../vue/Favouritesbutton.vue";
import Favouritewrapper from "../vue/Favouritewrapper.vue";

watchFavourites();

if (document.getElementById("filterVueApp")) {
    createApp({})
        .component("Lifestyle", Lifestyle)
        .component("Results", Results)
        .mount("#filterVueApp");
}

if (document.getElementById("productModulesWrapper")) {
    createApp({})
        .component("Favouritewrapper", Favouritewrapper)
        .component("Favouritesbutton", Favouritesbutton)
        .mount("#productModulesWrapper");
}

if (document.getElementById("productPageWrapper")) {
    createApp({})
        .component("Favouritewrapper", Favouritewrapper)
        .component("Favouritesbutton", Favouritesbutton)
        .mount("#productPageWrapper");
}

if (document.getElementById("otherFloorPlansWrapper")) {
    createApp({})
        .component("Favouritewrapper", Favouritewrapper)
        .component("Favouritesbutton", Favouritesbutton)
        .mount("#otherFloorPlansWrapper");
}

if (document.getElementById("productPageApp")) {
    createApp({})
        .component("Favouritebutton", Favouritebutton)
        .mount("#productPageApp");
}

if (document.getElementById("favouritesApp")) {
    createApp({}).component("Favourites", Favourites).mount("#favouritesApp");
}

if (document.getElementById("summaryVue")) {
    createApp({})
        .component("Summarywrapper", Summarywrapper)
        .mount("#summaryVue");
}

if (document.getElementById("vueWrapper")) {
    createApp({})
        .component("Configurator", Configurator)
        .component("Twigwrapper", Twigwrapper)
        .mount("#vueWrapper");

    var footers = document.getElementsByTagName("footer");
    footers[0].style = "z-index:0;";
}

if (document.getElementById("compareModels")) {
    createApp({}).component("Compare", Compare).mount("#compareModels");
}
